import { Outlet } from "react-router";

const PublicLayout = () => (
    <main>
        <Outlet />
    </main>
);

export default PublicLayout;
